import UpperPolicyList from '../../pages/policy/upper'
/**
 * 广告账户下载异常的路由配置。
 *
 * 如何访问"流程详情"路由：
 * this.$router.push({name: 'CustomerWorkflowDetail', params: {flowType: t, flowId: id}})
 */

export default [
  {
    name: 'UpperPolicyList',
    path: '/upper_policy_list',
    meta: { title: '媒体政策列表' },
    component: UpperPolicyList
  }
]
